import { useQuery } from '@tanstack/react-query';
import { GET_COUNTRIES } from '@/helpers/query-keys';
import { getCountries } from '@/services/qc.service';

export const useCountries = () => {
  return useQuery({
    queryKey: [GET_COUNTRIES],
    queryFn: async () => {
      const data = await getCountries();
      return data;
    },
    staleTime: Infinity,
  });
};
